export default "__VITE_ASSET__DS4dEe4C__"